// extracted by mini-css-extract-plugin
export default {"popUp":"style_popUp__OCgP8","cbnFooterContainer":"style_cbnFooterContainer__s8SNC"};